import { useCallback, useEffect, useState } from "react";

import { Form, Button, Modal, Spin, Popconfirm, Collapse } from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

import { FichaService } from "../../services/ficha.service";
import { Wrapper } from "./styles";

import { DadosPessoal } from "./components/DadosPessoal";
import { Endereco } from "./components/Endereco";
import { Sistema } from "./components/Sistema";

export function FormSolicitacaoAcesso() {
  const { Panel } = Collapse;

  function callback(key) {
    // console.log(key);
  }

  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [isTercerizado, setIsTercerizado] = useState(false);
  const [state, setState] = useState({
    anexoIdentidadeFuncional: null,
    anexoAtestadoAntecedente: null,
    anexoCertidaoCGD: null,
    anexoTermoConvenio: null,
    anexocertidaoForumTJCE: null,
    anexocertidaoForumTJCE2: null,
  });

  const [loading, setLoading] = useState(false);
  const finish = useCallback(
    async (values) => {
      setLoading(true);
      try {
        const tercerizado = values.isTercerizado;
        // if (!state.anexoAtestadoAntecedente) {
        //   toast.error(
        //     "Por favor, coloque o anexo do Atestado de Antecedentes Criminais da SSPDS-CE "
        //   );
        //   return;
        // }

        if (!state.anexoIdentidadeFuncional) {
          toast.error("Por favor, coloque o anexo da Identidade funcional");
          return;
        }

        if (!tercerizado && !state.anexoCertidaoCGD) {
          toast.error("Por favor, coloque o anexo da Certidão disciplinar CGD");
          return;
        }

        // if (!state.anexocertidaoForumTJCE || !state.anexocertidaoForumTJCE2 ) {
        //   toast.error(
        //     "Por favor, coloque o anexo da Certidão criminal do TJCE, 1º e 2º instância"
        //   );
        //   return;
        // }

        if (values.orgao !== "OUTROS") {
          if (!values.email.includes("ce.gov.br")) {
            toast.error("Por favor, informe o e-mail institucional.");
            return;
          }
          if (!values.emailChefeImediato.includes("ce.gov.br")) {
            toast.error(
              "Por favor, informe o e-mail institucional do chefe imediato."
            );
            return;
          }
        }

        const {
          // anexoAtestadoAntecedente,
          anexoCertidaoCGD,
          anexoIdentidadeFuncional,
          anexoTermoConvenio,
          // anexocertidaoForumTJCE,
          // anexocertidaoForumTJCE2
        } = state;

        if (values.orgaoLotacao) {
          values.orgao = values.orgaoLotacao;
          delete values.orgaoLotacao;
        }

        const patt1 = /[0-9]/g;
        const patt2 = /[0-9a-zA-Z]/g;
        const ais = values.ais;
        const cpf = values.cpf.match(patt1).join("");
        const telefone = values.telefone.match(patt1).join("");
        const telefoneLotacao = values.telefoneLotacao.match(patt1).join("");
        const matricula = values.matricula.match(patt2)
          ? values.matricula.match(patt2).join("")
          : null;
        const matriculaChefeImediato = values.matriculaChefeImediato
          ? values.matriculaChefeImediato.match(patt2).join("")
          : values.matriculaChefeImediato;
        const telefoneChefeImediato = values.telefoneChefeImediato
          ? values.telefoneChefeImediato.match(patt1).join("")
          : "";

        delete values.isTercerizado;
        const { data } = await FichaService.save({
          ...values,
          anexoCertidaoCGD,
          anexoIdentidadeFuncional,
          anexoTermoConvenio,
          cpf,
          telefone,
          telefoneLotacao,
          telefoneChefeImediato,
          matricula,
          matriculaChefeImediato,
          ais,
          tercerizado,
        });
        countDown(data.id);

        form.resetFields();
        setState({
          anexoIdentidadeFuncional: null,
          anexoAtestadoAntecedente: null,
          anexoTermoConvenio: null,
          anexoCertidaoCGD: null,
          anexocertidaoForumTJCE: null,
          anexocertidaoForumTJCE2: null,
        });
      } catch (err) {
        toast.error("Erro ao tentar salvar a ficha, tente novamente!");
      } finally {
        setLoading(false);
      }
    },
    [form, state]
  );

  const showPopconfirm = () => {
    setVisible(true);
  };

  const updateFile = useCallback(
    (newValues) => setState((prev) => ({ ...prev, ...newValues })),
    []
  );

  function countDown() {
    let secondsToGo = 5;
    // \n Protocolo: ${id}
    const modal = Modal.success({
      title: `Salvo com sucesso. `,
      content: ``,
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: `A modal será fechado em ${secondsToGo} segundos.`,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
    }, secondsToGo * 1000);
  }

  const info = useCallback(() => {
    Modal.info({
      title: "AVISO",
      style: { width: "1200px" },
      content: (
        <div>
          <h3>
            PORTARIA NORMATIVA Nº0443/2022-GS. ALTERA A PORTARIA NORMATIVA
            Nº1232/2021-GS, QUE DISCIPLINA AS REGRAS GERAIS DE DISPONIBILIZAÇÃO,
            MODIFICAÇÃO, SUSPENSÃO E EXCLUSÃO DE ACESSO AOS SISTEMAS PORTAL DE
            COMANDO AVANÇADO (PCA), CONSULTA INTEGRADA, CEREBRUM, AGILIS, ROTAS
            E SPIA. Parte da Portaria considerada secreta, por força da 11.º
            Reunião do Comitê Gestor de Acesso a Informação, realizada em 15 de
            dezembro de 2015, da Portaria CGAI n.º 01/2016, com amparo na Lei
            Estadual n.º 15.175/2012. SECRETARIA DA SEGURANÇA PÚBLICA E DEFESA
            SOCIAL, em Fortaleza, 7 de março de 2022.
          </h3>
        </div>
      ),
      onOk() {},
    });
  }, []);

  useEffect(() => {
    info();
  }, [info]);

  return (
    <Spin spinning={loading}>
      <Wrapper>
        <Form
          layout="vertical"
          autoComplete="off"
          onFinish={finish}
          form={form}
          className="formConteiner"
          name="basic"
        >
          <DadosPessoal
            isTercerizado={isTercerizado}
            setIsTercerizado={setIsTercerizado}
          />

          <Endereco form={form} setLoading={setLoading} />

          <Sistema form={form} updateFile={updateFile} />

          <br />
          <Collapse defaultActiveKey={["1"]} onChange={callback}>
            <Panel className="panelStyle" header="Compromisso Legal" key="1">
              <p>
                1. Guardar a privacidade e o sigilo das informações constantes
                nos sistemas da SSPDS, mesmo após o cancelamento de seu acesso
                ou o seu desligamento do órgão;
              </p>
              <p>
                2. Utilizar as informações disponíveis nos sistemas somente nas
                atividades que compete exercer, tendo desde já ciência de que as
                consultas aos sistemas são passíveis de auditorias;
              </p>
              <p>
                3. Guardar o sigilo e a privacidade do código de usuário e da
                senha solicitados e autorizados, os quais são pessoais e
                intransferíveis, para acesso aos sistemas, sendo responsável
                pelo uso indevido das informações neles constantes, estando
                sujeito às normas legais aplicáveis, não podendo fornecê-los ou
                transferi-los a terceiros, inclusive a outros servidores com
                quem compartilhe o ambiente de trabalho;
              </p>
              <p>
                4. Por qualquer que seja o motivo do desligamento ou da mudança
                de lotação do ora solicitante que venha a acarretar em
                necessidade de mudança de perfil de acesso, deverá este
                solicitar a sua readequação de nível;
              </p>
              <p>
                5. CUMPRIR as determinações específicas da Política de Segurança
                da Informação dos Sistemas e demais legislações pertinentes, dos
                ambientes de tecnologia da informação e comunicação (TIC) do
                Governo do Estado do Ceará (Decreto nº 29.227, de 13/03/2008),
                bem como da Portaria Normativa nº 0443/2022-GS. O usuário
                autorizado e autenticado nos sistemas incorre nos crimes
                descritos no Código Penal Brasileiro, sem prejuízo das sanções
                cíveis e administrativas, pelo uso ou divulgação indevida das
                informações.
              </p>
            </Panel>

            <Panel className="panelStyle" header="Declaração" key="2">
              <p>
                Declaro, sob as penas da lei, verdadeiras as informações neste
                ato Prestadas, fazendo parte integrante dos registros e arquivos
                da Secretaria da segurança pública e defesa social (sspds),
                Compreendendo o que estabelecem os artigos 153, § 1ºa; <br />
                299 "caput" E parágrafo único; 313-a; 313-b; 325 "caput" e §§ 1º
                e 2º; 327 "caput" e §§ 1º e 2º, do código penal brasileiro, a
                legislação Aplicada ao assunto e demais normas complementares
                (inclusive a Portaria normativa nº 0443/2022-gs) do sistema,
                aquiescendo com Todas as responsabilidades inerentes ao uso das
                informações Privilegiadas e de natureza de segurança pública
                nacional, bem Como das implicações legais decorrentes do uso
                indevido das Informações e do acesso, seja qual for a
                circunstância, Constituindo o usuário e a senha disponibilizados
                para o acesso Propriedade da sspds e sujeito ao monitoramento e
                ao controle das Ações realizadas nos sistemas.
              </p>
            </Panel>
          </Collapse>

          <br />

          <div className="conteinarButton">
            <Popconfirm
              title="Declaro que li e estou ciente dos termos acima"
              visible={visible}
              onConfirm={() => {
                setVisible(false);
                form.submit();
              }}
              onCancel={() => setVisible(false)}
            >
              <Button
                className="button"
                icon={<CheckCircleOutlined />}
                type="primary"
                htmlType="button"
                onClick={showPopconfirm}
              >
                Salvar
              </Button>
            </Popconfirm>
          </div>
        </Form>

        <Form
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 10 }}
          initialValues={{ remember: true }}
        ></Form>
      </Wrapper>
    </Spin>
  );
}
